"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
// styles
require("./spinner.scss");
// use the optional prop interface to define the default props
const defaultProps = {
    size: "medium",
    "data-testid": "tecma-spinner",
    type: "circle",
};
const Spinner = (_a) => {
    var { size, gradient, type, className } = _a, rest = __rest(_a, ["size", "gradient", "type", "className"]);
    const classList = (0, classnames_1.default)("tecma-spinner", { [`${size}`]: size }, { gradient }, { [`${type}`]: type }, className);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [type === "circle" && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classList }, rest)), type === "dotted" && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classList }, rest, { children: [(0, jsx_runtime_1.jsx)("div", { className: "dot" }), (0, jsx_runtime_1.jsx)("div", { className: "dot" }), (0, jsx_runtime_1.jsx)("div", { className: "dot" })] })))] }));
};
Spinner.defaultProps = defaultProps;
exports.default = react_1.default.memo(Spinner);
